var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-detail-status"},[_c('device-component-list',{ref:"list",attrs:{"bodyNum":_vm.bodyNum}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }